export default __webpack_public_path__ + "static/media/linkedin-new-icon.a63fe874.svg";